import classNames from 'classnames';
import * as React from 'react';

interface ICommonPopupBodyFooter {
    body: React.ReactNode;
    footer?: React.ReactNode;
    emptyGuidelines?: boolean;
    className?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref?: React.MutableRefObject<any>;
}

/**
 * to be used for views when popup container '.oe-popup-layout' is is rendered by outer component
 * for example while rendering sub-windows -
 * maximized content component consists only from footer and body while header is defined by sub-window component.
 * @param props
 * @constructor
 */
const CommonPopupBodyFooterLayout = (props: ICommonPopupBodyFooter) => {
    return (
        <>
            <div className={
                classNames(
                    'oe-popup-layout__body',
                    {'empty-guidelines': props.emptyGuidelines},
                    props.className
                )}
            >
                {props.body}
            </div>
            {props.footer && <div className='oe-popup-layout__footer'>
                {props.footer}
            </div>}
        </>
    );
};

export { CommonPopupBodyFooterLayout };
